/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type CreateSweetpassPaymentIntentInput = {
  readonly amount: number;
  readonly paymentMethodId: string;
  readonly shouldSetupFutureUsage?: boolean | null | undefined;
  readonly sweetpassId: string;
};

export type CreateSweetpassPaymentIntentMutationVariables = Exact<{
  input: Types.CreateSweetpassPaymentIntentInput;
}>;

export type CreateSweetpassPaymentIntentMutation = {
  readonly createSweetpassPaymentIntent:
    | {
        readonly __typename: 'PaymentIntent';
        readonly id: string;
        readonly secret: string;
        readonly orderId: string;
      }
    | { readonly __typename: 'SweetpassAlreadyPurchasedError'; readonly errorMessage: string }
    | {
        readonly __typename: 'UnableToCreateSweetpassPaymentIntentError';
        readonly errorMessage: string;
      };
};

export const CreateSweetpassPaymentIntentDocument = gql`
  mutation CreateSweetpassPaymentIntent($input: CreateSweetpassPaymentIntentInput!) {
    createSweetpassPaymentIntent(input: $input) {
      __typename
      ... on PaymentIntent {
        id
        secret
        orderId
      }
      ... on SweetpassAlreadyPurchasedError {
        errorMessage
      }
      ... on UnableToCreateSweetpassPaymentIntentError {
        errorMessage
      }
    }
  }
`;

export function useCreateSweetpassPaymentIntentMutation() {
  return Urql.useMutation<
    CreateSweetpassPaymentIntentMutation,
    CreateSweetpassPaymentIntentMutationVariables
  >(CreateSweetpassPaymentIntentDocument);
}
